<template>
    <div class="bg-[#23242A] text-white app-header custom p-3" id="content_screen">
      <div v-if="vg_selectedLocation.id">
        <div class="px-3 pt-3 flex content-main">
          <div class="custom-full customer-list">
            <div class="bg-[#2B2C32] rounded-lg max-w-full">
              <List/>
            </div>
          </div>
        </div>
      </div>
  
      <div class="flex lg:flex-row flex-col bg-[#2B2C32] rounded-xl" v-else> 
          <div class="w-full">
            <div class="bg-[#2B2C32] rounded-lg px-8 py-[16px]">
              <p  class="text-center text-theme-red">Please select a location from the top left corner.</p>
            </div>
          </div>
      </div>
  
    </div>
  </template>
  
  
  <script lang="ts">
  import {defineComponent, ref} from "vue"
  import { mapGetters, mapActions, mapMutations } from "vuex";
  import List from '@/views/Membership/ExportLog/List.vue';

  
    export default defineComponent({
    name: "ProductSales",
    components: {
      List,
    },
  
    computed: {
  
      ...mapGetters({
       vg_selectedLocation: 'location/selected'
      }),
    },
   
    methods: {
  
      ...mapActions({
        va_spinner: 'spinner/setSpinner',
      })
    },
  });
  
  </script>